import { primaryDateFormat } from "@agrigate/ts-utils/lib/datetime";
import { addDays, addMonths, endOfMonth, endOfQuarter, endOfWeek, format, startOfMonth, startOfQuarter, startOfWeek, subDays, subQuarters, subYears, } from "date-fns";
export function getFinancialYearDates(date) {
    const currentDate = date || new Date();
    const financialYearStart = currentDate.getMonth() < 3
        ? new Date(currentDate.getFullYear() - 1, 3, 1)
        : new Date(currentDate.getFullYear(), 3, 1);
    const financialYearEnd = subDays(new Date(currentDate.getFullYear() + 1, 3, 1), 1);
    return {
        start: financialYearStart,
        end: financialYearEnd,
    };
}
const currentFinancialYear = getFinancialYearDates();
export const predefinedRanges = [
    {
        label: "Today",
        value: [new Date(), new Date()],
        placement: "left",
    },
    {
        label: "Yesterday",
        value: [addDays(new Date(), -1), addDays(new Date(), -1)],
        placement: "left",
    },
    {
        label: "This week",
        value: [startOfWeek(new Date()), endOfWeek(new Date())],
        placement: "left",
    },
    {
        label: "Last 7 days",
        value: [subDays(new Date(), 6), new Date()],
        placement: "left",
    },
    {
        label: "Last 30 days",
        value: [subDays(new Date(), 29), new Date()],
        placement: "left",
    },
    {
        label: "This month",
        value: [startOfMonth(new Date()), new Date()],
        placement: "left",
    },
    {
        label: "Last month",
        value: [
            startOfMonth(addMonths(new Date(), -1)),
            endOfMonth(addMonths(new Date(), -1)),
        ],
        placement: "left",
    },
    {
        label: "Last 3 months",
        value: [
            startOfMonth(addMonths(new Date(), -3)),
            endOfMonth(addMonths(new Date(), -1)),
        ],
        placement: "left",
    },
    {
        label: "Last 6 months",
        value: [
            startOfMonth(addMonths(new Date(), -6)),
            endOfMonth(addMonths(new Date(), -1)),
        ],
        placement: "left",
    },
    {
        label: "This quarter",
        value: [startOfQuarter(new Date()), new Date()],
        placement: "left",
    },
    {
        label: "Last quarter",
        value: [
            startOfQuarter(subQuarters(new Date(), 1)),
            endOfQuarter(subQuarters(new Date(), 1)),
        ],
        placement: "left",
    },
    {
        label: "Current FY",
        // value: [new Date(new Date().getFullYear(), 0, 1), new Date()],
        value: [currentFinancialYear.start, currentFinancialYear.end],
        placement: "left",
    },
    {
        label: "Last FY",
        value: [
            subYears(currentFinancialYear.start, 1),
            subYears(currentFinancialYear.end, 1),
        ],
        // value: [new Date(new Date().getFullYear() - 1, 0, 1), new Date(new Date().getFullYear(), 0, 0)],
        placement: "left",
    },
    {
        label: "All time",
        value: [new Date(new Date().getFullYear() - 1, 0, 1), new Date()],
        placement: "left",
    },
];
/**
 * Converts a given time frame label into a corresponding date range.
 *
 * @param {string} [timeFrame] - A label such as "Today", "Yesterday", or "Last Week".
 * Must match one of the labels from `predefinedRanges` defined in `/shared/src/consts/predefined-date-ranges`.
 * @returns {object} An object containing `start` and `end` dates in the primary date format,
 * e.g., { start: "01/12/2025", end: "22/12/2025" }, or `undefined` if the label doesn't match.
 */
export const rangeLabelToDateRange = (timeFrame) => {
    const selTimeFrame = predefinedRanges.find(item => item.label === timeFrame)?.value;
    return {
        start: selTimeFrame?.[0] && format(selTimeFrame?.[0], primaryDateFormat),
        end: selTimeFrame?.[1] && format(selTimeFrame?.[1], primaryDateFormat),
    };
};
//# sourceMappingURL=predefined-date-ranges.js.map